module.exports = __webpack_public_path__ + "img/entertainment-media-storage.841f915.jpg";